<template>
  <el-dialog title="新增实际回款" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="120px">
      <el-form-item label="客户名称:" prop="customerId">
        <el-select v-model="data.customerId" placeholder="请选择客户" @change="customerChange" filterable clearable style="width:100%">
          <el-option v-for="dict in customerList" :key="dict.id" :label="dict.customerName" :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="合同:" prop="contractId">
        <el-select v-model="data.contractId" placeholder="请选择合同" @change="contractChange" clearable style="width:100%">
          <el-option v-for="dict in contractList" :key="dict.contractId" :label="dict.contractNum" :value="dict.contractId"/>
        </el-select>
      </el-form-item>
      <el-form-item label="关联回款计划:" prop="contractPlanFundId">
        <el-select v-model="data.contractPlanFundId" placeholder="请选择回款计划" clearable style="width:100%">
          <el-option
            v-for="dict in planFundList"
            :key="dict.id"
            :label="dict.planFundBatch + '(计划回款' + amountFormat(dict.planFundAmount) + '，实际回款' + amountFormat(dict.actualAmount) + ')'"
            :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item label="本次回款金额:" prop="actualFundAmount">
        <el-input-number
          v-model="data.actualFundAmount"
          placeholder="请输入本次回款金额"
          :max="999999999"
          :precision="2"
          :controls="false"
          clearable
          class="crm-input-number-wrap"
        />
        <span class="el-input__suffix">元</span>
      </el-form-item>
      <el-form-item label="本次回款时间:" prop="actualFundDate">
        <el-date-picker v-model="data.actualFundDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
      </el-form-item>
      <fund-owner-select ref="fundOwnerSelectRef" :form-param="data"/>
      <el-form-item label="支付方式" prop="payType">
        <el-select v-model="data.payType" placeholder="请选择支付方式" clearable style="width:100%">
          <el-option v-for="dict in payTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
      <el-form-item label="回款银行" prop="bank">
        <el-select v-model="data.bank" placeholder="请选择回款银行" clearable style="width:100%">
          <el-option v-for="dict in bankOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listSimpleAll } from "@/api/crm/customer";
import { listContract } from "@/api/crm/contract";
import { listContractPlanFund } from "@/api/crm/planFund";
import { createContractFundRecord } from "@/api/crm/fundRecord";
import { mapState } from 'vuex'
import {amountFormat} from '@/utils/index';
import FundOwnerSelect from "@/views/crm/fundRecord/fundOwnerSelect";

export default {
  name: "AddFundRecordDialog",
  props: {
  },
  data() {
    return {
      amountFormat,
      visible: false,
      customerList: [],
      contractList: [],
      planFundList: [],
      payTypeOptions: [],
      bankOptions: [],
      rules: {
        customerId: [
          {required: true, type: 'number', message: '请选择客户', trigger: 'change'}
        ],
        contractId: [
          {required: true, type: 'number', message: '请选择合同', trigger: 'change'}
        ],
        contractPlanFundId: [
          {required: true, type: 'number', message: '请选择回款计划', trigger: 'change'}
        ],
        actualFundAmount: [
          {required: true, type:'number', message: '请输入本次回款金额', trigger: 'blur'}
        ],
        actualFundDate: [
          {required: true, message: '请选择本次回款时间', trigger: 'change'}
        ],
        fundDeptId: [
          {required: true, message: '请选择回款部门', trigger: 'change'}
        ],
        fundUserId: [
          {required: true, message: '请选择回款人', trigger: 'change'}
        ],
        payType: [
          {required: true, message: '请选择支付方式', trigger: 'change'}
        ],
        bank: [
          {required: true, message: '请选择回款银行', trigger: 'change'}
        ]
      },
      data: {
        customerId: null,
        contractId: null,
        contractPlanFundId: null,
        actualFundAmount: undefined,
        actualFundDate: null,
        fundDeptId: null,
        fundUserId: null,
        payType: null,
        bank: null,
      }
    };
  },
  created() {
    listSimpleAll().then(response => {
      this.customerList = response.data;
    });
    this.getDicts("pay_type").then(response => {
      this.payTypeOptions = response.data;
    });
    this.getDicts("bank").then(response => {
      this.bankOptions = response.data;
    });
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    FundOwnerSelect
  },
  watch: {
    visible (val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    customerChange (customerId) {
      this.contractList = [];
      this.planFundList = [];
      this.data.contractId = null;
      this.data.contractPlanFundId = null;
      this.data.fundDeptId = null;
      this.data.fundUserId = null;
      if (customerId) {
        listContract({customerId: customerId}).then(response => {
          this.contractList = response.data || [];
        });
      }
    },
    contractChange (contractId) {
      this.planFundList = [];
      this.data.contractPlanFundId = null;
      const contract = this.contractList.find(item => item.contractId === contractId)
      this.$nextTick(() => {
        if (this.$refs.fundOwnerSelectRef) {
          this.$refs.fundOwnerSelectRef.setSelection(
            contract ? contract.assignDeptId : null,
            contract ? contract.assignUserId : null
          )
        }
      })
      if (contractId) {
        listContractPlanFund({contractId: contractId}).then(response => {
          this.planFundList = response.rows || [];
        });
      }
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          createContractFundRecord(this.data).then(response => {
            this.$emit('success')
            this.visible = false
            loading.close();
            this.msgSuccess("实际回款新增成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
